module.exports = require("./../../_gen/openfl/utils/Assets");